import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// ref profile svg icon components for AbstractIcon
import { DirectivesModule } from '../../core-ui/Directives/Directives.module';
import { AbstractIconComponent } from './AbstractIcon.component';
import { BAReportIconComponent } from './BAReportIcon.component';
import { BarGraphIconComponent } from './BarGraphIcon.component';
import { CellRemoveIconComponent } from './CellRemoveIcon.component';
import { ClipboardIconComponent } from './ClipboardIcon.component';
import { LetterComponent } from './Letter.component';
import { LineGraphIconComponent } from './LineGraphIcon.component';
import { NumberListIconComponent } from './NumberedListIcon.component';
import { PieChartIconComponent } from './PieChartIcon.component';
import { PlacardIconComponent } from './PlacardIcon.component';
import { RutherfordAtomIconComponent } from './RutherfordAtomIcon.component';
import { SlidersIconComponent } from './SlidersIcon.component';
import { SpeechBubbleIconComponent } from './SpeechBubbleIcon.component';
import { TacticsIconComponent } from './TacticsIcon.component';

export const IconsModuleExports = [AbstractIconComponent, LetterComponent];

@NgModule({
    imports: [CommonModule, DirectivesModule],
    declarations: [
        AbstractIconComponent,
        SlidersIconComponent,
        BAReportIconComponent,
        PlacardIconComponent,
        LineGraphIconComponent,
        ClipboardIconComponent,
        PieChartIconComponent,
        BarGraphIconComponent,
        RutherfordAtomIconComponent,
        SpeechBubbleIconComponent,
        NumberListIconComponent,
        TacticsIconComponent,
        LetterComponent,
        CellRemoveIconComponent
    ],
    exports: [AbstractIconComponent, LetterComponent],
    providers: []
})
export class IconsModule {}
